import {PtPermissions} from "@pt/pt-models";
import {UserPermissions} from "it/primatoo/openapi/api/adm/schemas/login/UserPermissions";
import {DocCreationCapability} from "it/primatoo/openapi/api/common/schemas/DocCreationCapability";

const SYSTEM_PERMISSIONS = [
  PtPermissions.DPG,
  PtPermissions.MANAGE_DATABREACH,
  PtPermissions.MANAGE_WORKSPACE,
  PtPermissions.CAN_CREATE_AI_AS,
  PtPermissions.CAN_CREATE_APP_AS,
  PtPermissions.CAN_CREATE_COVID_AS,
  PtPermissions.CAN_CREATE_TREAT,
  PtPermissions.CAN_CREATE_DATABREACH,
  PtPermissions.ENABLE_FOR_SYSTEM
];

const ADMIN_PERMISSIONS = [
  PtPermissions.DPG,
  PtPermissions.MANAGE_DATABREACH,
  PtPermissions.MANAGE_WORKSPACE,
  PtPermissions.CAN_CREATE_AI_AS,
  PtPermissions.CAN_CREATE_APP_AS,
  PtPermissions.CAN_CREATE_COVID_AS,
  PtPermissions.CAN_CREATE_DATABREACH,
  PtPermissions.CAN_CREATE_TREAT,
  PtPermissions.ENABLE_FOR_ADMIN
];

export class AuthPermissionsUtils {
  public static buildPermissions(isASystemUser: boolean, userPermissions?: UserPermissions): PtPermissions[] {
    const p: Array<PtPermissions> = [];
    if (isASystemUser) {
      return SYSTEM_PERMISSIONS;
    }
    if (userPermissions) {
      if (userPermissions.admin) {
        return ADMIN_PERMISSIONS;
      }
      if (userPermissions.capabilities) {
        const capabilities = userPermissions.capabilities;
        if (capabilities.dpg) {
          p.push(PtPermissions.DPG);
        }
        if (capabilities.dtb) {
          p.push(PtPermissions.MANAGE_DATABREACH);
        }
        if (capabilities.workspace) {
          p.push(PtPermissions.MANAGE_WORKSPACE);
        }


        if (capabilities.docsCreation && capabilities.docsCreation.length > 0) {
          capabilities.docsCreation.forEach((dc: DocCreationCapability) => {
            p.push(`CAN_CREATE_${dc}` as PtPermissions);
          });
        }
        return p;
      }
    }
    return p
  }
}
